import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

// components
import {
  Box,
  MainHolder,
  RegionCitySelector,
  StyledText,
} from "../../../components/common";

//svgs
import { NewBackButton } from "../../../components/svgs";
import VendorCard from "../../../components/trivia/vendorCard";
import { OfferAlertModal } from "../../../components/loyalty";

// hooks
import { useTheme, useTrivia } from "../../../hooks";

const Vendor = () => {
  const history = useHistory();
  const [showModalUnavailable, setModalUnavailable] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [unavailableMsg, setModalUnavailableMsg] = useState(
    "You have exhausted your number of tries for this trivia and can no longer play."
  );
  const [showModalQualified, setModalQualified] = useState(false);
  const [ticketCode, setTicketCode] = useState("");
  const { themeContext, theme } = useTheme();

  const themeColor = theme.colors[themeContext.activeTheme]["background"];

  const { trivia, setActiveTrivia, saveTriviaUserDisqualified } = useTrivia();

  const requestConfirmation = (triv) => {
    setShowConfirmationModal(true);
    setActiveTrivia(triv);
    // history.push("/trivia/play");
  };

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  return (
    <MainHolder>
      {showConfirmationModal && (
        // <ConfirmModal
        //   background={themeColor}
        //   title='Are you in Cape Coast for Ogua Festival?'
        //   description={" "}
        //   handleOnConfirm={() => history.push("/trivia/play")}
        //   hideModal={() => {
        //     setModalUnavailableMsg(
        //       "Only available for persons in Cape Coast for Ogua Festival."
        //     );
        //     setModalUnavailable(true);
        //     setShowConfirmationModal(false);
        //   }}
        // />
        <RegionCitySelector
          title={"Please select your location"}
          sendLocation={(selectedRegion, selectedCity) => {
            if (
              selectedRegion !== "Central Region" ||
              !selectedCity.includes("Cape Coast")
            ) {
              // setModalUnavailableMsg(
              //   "Only available for persons in Cape Coast for Ogua Festival."
              // );
              // setModalUnavailable(true);
              // setShowConfirmationModal(false);

              const { _id } = trivia[0];

              saveTriviaUserDisqualified(_id);

              setModalUnavailableMsg(
                "Only available for persons in Cape Coast for Ogua Festival."
              );
              setModalUnavailable(true);
              setShowConfirmationModal(false);
            } else {
              history.push("/trivia/play");
            }

            setShowConfirmationModal(false);
          }}
        />
      )}
      {showModalUnavailable && (
        <OfferAlertModal
          background={themeColor}
          hideModal={() => {
            setModalUnavailable(false);
            goToHome();
          }}
          title='Trivia not available'
          description={unavailableMsg}
        />
      )}
      {showModalQualified && (
        <OfferAlertModal
          background={themeColor}
          hideModal={() => setModalQualified(false)}
          title={ticketCode && "Congratulations"}
          description={`${
            ticketCode
              ? `You won. Please present your code ${ticketCode} to the MTN representative at the Fetu Festival for redemption.`
              : ""
          }`}
        />
      )}

      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          padding: 15,
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
          }}
        >
          <BackButtonContainer onClick={() => history.goBack()}>
            <NewBackButton />
          </BackButtonContainer>
          <StyledText
            style={{ flex: 1, display: "flex", justifyContent: "center" }}
            size={20}
          >
            Select Trivia
          </StyledText>
        </Box>
        <Box
          style={{
            display: "flex",
            flex: 1,
            backgroundColor: "white",
          }}
        >
          {trivia === null && <StyledText>Loading...</StyledText>}
          {Array.isArray(trivia) &&
            trivia.map((triv) => {
              const {
                userStats: {
                  hasWon,
                  attempts,
                  wonData,
                  hasPlayed,
                  isDisqualified,
                },
                maxAttempts,
                // isClosed,
                _id,
              } = triv;
              const triesRemaining = maxAttempts - attempts;

              const {
                // voucher,
                referenceCode,
              } = wonData || {};

              return (
                <VendorCard
                  key={_id}
                  onClick={() => {
                    if (isDisqualified) {
                      setModalUnavailableMsg(
                        "Only available for persons in Cape Coast for Ogua Festival."
                      );
                      setModalUnavailable(true);
                      return;
                    }
                    // if (voucher) {
                    //   setTicketCode(
                    //     `${voucher.toUpperCase()} \n${referenceCode}`
                    //   );
                    // }
                    if (hasWon) {
                      setActiveTrivia(triv);

                      // if (!voucher) {
                      //   history.push("/trivia/pick");
                      //   return;
                      // }

                      // setTicketCode(
                      //   `${voucher.toUpperCase()} \n${referenceCode}`
                      // );

                      setTicketCode(`${referenceCode}`);

                      setModalQualified(true);

                      return;
                    }
                    // if (isClosed) {
                    //   setModalUnavailableMsg("");
                    //   return setModalUnavailable(true);
                    // }

                    if (hasPlayed) {
                      setModalUnavailableMsg(
                        "Sorry you have already played this game."
                      );
                      return setModalUnavailable(true);
                    }

                    if (triesRemaining > 0) {
                      requestConfirmation(triv);
                    } else {
                      setModalUnavailable(true);
                    }
                  }}
                  tag={
                    hasWon
                      ? "Won"
                      : hasPlayed
                      ? "Played"
                      : isDisqualified
                      ? "Unavailable"
                      : `${triesRemaining} ${
                          triesRemaining > 1 ? "attempts" : "attempt"
                        }`
                  }
                  backgroundImage={triv.imageUrl}
                  description={triv.description}
                  title={triv.title}
                />
              );
            })}
        </Box>
      </div>
    </MainHolder>
  );
};

export default Vendor;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
